import React from 'react'
import { Link } from 'react-router-dom';
import certificate from '../../assets/images/certificate1.png'
import { FaWhatsapp } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";
export default function Footer() {
  return (
    <footer id="footer" className="mt-5">
      <div className="container">
        <div className="row d-flex flex-wrap justify-content-between py-5">
          <div className="col-md-3 col-sm-6">
            <div className="footer-menu footer-menu-001">
              <div className="footer-intro mb-4">
                <Link href="index.html">
                  <img src="../../assets/images/kvrLogo.png" alt="logo" style={{ width: '110px', marginLeft: '-13px', marginTop: '-10px' }} />
                </Link>
              </div>
              <div className=''>
                <img src={certificate} className='w-100 border border-light mb-3' style={{ marginTop: '-1rem' }} alt="" />
              </div>
              <p>
                To inspire confidence and comfort through timeless knitwear that blends global style with Indian craftsmanship
              </p>
              <div className="social-links">
                <ul className="list-unstyled d-flex flex-wrap gap-3">
                  <li>
                    <Link to="https://wa.me/917398333330?text=Hi%20I%20want%20to%20enquire%20about%20bulk%20orders" className="text-secondary">
                     <FaWhatsapp style={{width:'24px', height:'26px'}}/>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.facebook.com/share/1G1zLugpqk/?mibextid=wwXIfr" className="text-secondary">
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <use xlinkHref="#facebook"></use>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="https://www.linkedin.com/in/ankush-jain-65a3a1391?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" className="text-secondary">
                        <CiLinkedin style={{width:'30px', height:'31px'}}/>
                    </Link>
                  </li>
                  {/* <li>
                    <Link href="#" className="text-secondary">
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <use xlinkHref="#twitter"></use>
                      </svg>
                    </Link>
                  </li> */}
                  
                  {/* <li>
                    <Link href="#" className="text-secondary">
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <use xlinkHref="#pinterest"></use>
                      </svg>
                    </Link>
                  </li> */}
                  <li>
                    <Link to="https://www.instagram.com/kvr_knitwears?igsh=MXRtd2ZqeDU1OXdqOQ==" className="text-secondary">
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <use xlinkHref="#instagram"></use>
                      </svg>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="footer-menu footer-menu-002">
              <h5 className="widget-title text-uppercase mb-4">Quick Links</h5>
              <ul className="menu-list list-unstyled text-uppercase border-animation-left fs-6">
                <li className="menu-item">
                  <Link to="/" className="item-anchor">Home</Link>
                </li>
                <li className="menu-item">
                  <Link to="/about" className="item-anchor">About</Link>
                </li>
                <li className="menu-item">
                  <Link to='/blogs' className="item-anchor">Blog</Link>
                </li>
                <li className="menu-item">
                  <Link to='/contact' className="item-anchor">Contact</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="footer-menu footer-menu-003">
              <h5 className="widget-title text-uppercase mb-4">Help & Info</h5>
              <ul className="menu-list list-unstyled text-uppercase border-animation-left fs-6">
                <li className="menu-item">
                  <Link to="/contact" className="item-anchor">Contact Us</Link>
                </li>
                <li className="menu-item">
                  <Link href="#" className="item-anchor">Find us easy</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3 col-sm-6">
            <div className="footer-menu footer-menu-004 border-animation-left">
              <h5 className="widget-title text-uppercase mb-4">Contact Us</h5>
              <p>Do you have any questions or suggestions? <Link href="mailto:info@kvrwears.com"
                className="item-anchor">info@kvrwears.com</Link></p>
              <p>Do you need support? Give us a call. <a href="tel:+91 7398333330" className="item-anchor">
                +91 7398333330
              </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="border-top py-4">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex flex-wrap">
              <div className="shipping">
                <span>We ship with:</span>
                <img src="../../assets/images/arct-icon.png" alt="icon" />
                <img src="../../assets/images/dhl-logo.png" alt="icon" />
              </div>
              <div className="payment-option">
                <span>Payment Option:</span>
                <img src="../../assets/images/visa-card.png" alt="card" />
                <img src="../../assets/images/paypal-card.png" alt="card" />
                <img src="../../assets/images/master-card.png" alt="card" />
              </div>
            </div>
            <div className="col-md-6 text-end">
              <p>© Copyright 2025 KVR Knitwears. All rights reserved. Design by <Link href="https://jdtechnicalsolution.com"
                target="_blank">JDTechnicalSolution</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
